import React from "react";
import { useFormState } from "react-hook-form";

import { Button, ButtonProps } from "@mui/material";

export const SubmitButton = ({ type = "submit", variant = "contained", disabled, ...rest }: ButtonProps) => {
  const { isSubmitting } = useFormState();
  return <Button type={type} variant={variant} disabled={disabled || isSubmitting} {...rest} />;
};

export const CancelButton = ({ type = "button", variant = "outlined", disabled, ...rest }: ButtonProps) => {
  const { isSubmitting } = useFormState();
  return <Button type={type} variant={variant} disabled={disabled || isSubmitting} {...rest} />;
};
